import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/pyotp",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const googleAuthApi = createApi({
  reducerPath: "googleAuthApi",
  baseQuery,
  endpoints: (builder) => ({
    getAuthCodes: builder.query({
      query: () => "/get-token",
      skip: true,
    }),
  }),
});

export const { useGetAuthCodesQuery } = googleAuthApi;
